import { faRectangleList } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { makeStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionSummary,
  Button,
  Card,
  TextField,
  Grid,
  Paper,
  Typography,
  Tooltip,
  IconButton,
} from "@mui/material";
import {
  faFileCsv,
  faFileExcel,
  faFileImage,
  faFileLines,
  faFilePdf,
  faFilePowerpoint,
  faFileSpreadsheet,
  faFileWord,
  faPlugCirclePlus,
  faPlusCircle,
  faTrash,
} from "@fortawesome/pro-duotone-svg-icons";
import AccordionDetails from "@mui/material/AccordionDetails";
import Checkbox from "@mui/material/Checkbox";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Icon } from "@progress/kendo-react-common";
import { useFormik } from "formik";
import moment from "moment";
import React, { Fragment, useEffect, useMemo, useState, useRef } from "react";
import { Container, Row, Col } from "reactstrap";
import * as Yup from "yup";
import Depedentinformation from "./Components/Depedentinformation";
import EmployeeDetails from "./Components/EmployeeDetails";
import HealthAndDeductionPlan from "./Components/HealthAndDeductionPlan";
import axios from "axios";
import { ShowError, ShowSucess, getUserRole, removeKeyFromObjects } from "../../_helper/helper";
import { loadingPanel } from "../CommonFunction";
import ActiveHealthAndDeductionPlan from "./Components/ActiveHealthAndDeductionPlan";
import companyArray from "./Components/CompanyArray.json";
import { useAuth } from "oidc-react";
import { Btn } from "../../AbstractElements";
import Errorlable from "./Components/Errorlable";
import { Controller, set, useForm } from "react-hook-form";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { bindActionCreators } from "@reduxjs/toolkit";
import { useNavigate, useParams } from "react-router-dom";
import {
  getDocumentFields,
  getDocumentSources,
  postDocuments,
} from "../../store/DocumentUpload/actions";
import { connect } from "react-redux";
import { Add, Remove, Visibility, VisibilityOff } from "@mui/icons-material";
import DocumentViewer from "../DocumentViewer";
import { DesktopDateTimePicker } from "@mui/x-date-pickers/DesktopDateTimePicker";
import dayjs from 'dayjs';
import { error } from "highcharts";
import { format } from "date-fns";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    ".&.MuiExpansionPanelSummary-content": {
      padding: 0,
    },
    ".css-sh22l5-MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded": {
      minHeight: "32px",
      margin: "0px !important",
    },
    "& .MuiPaper-root": {
      background: "none",
      display: "block",
    },

    margin: "0 !important",
    borderTopWidth: 1,
    borderTopColor: "#ccc",
  },
  asterisk: {
    color: "red !important",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "70%",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    fontWeight: "bold",
  },
}));
const documents = [
  { index: 0, title: "DEATH CERTIFICATE", docName: "docDc", sourceId: 1220 },
  { index: 1, title: "FOREIGN DEATH QUESTIONNAIRE", docName: "docFdq", sourceId: 1221 },
  { index: 2, title: "MARRIAGE CERTIFICATE", docName: "docMc", sourceId: 1222 },
  { index: 3, title: "BIRTH CERTIFICATE– FOR DEPENDENT COVERAGE (STEPCHILD)", docName: "docBcdc", sourceId: 1223 },
  { index: 4, title: "POWER OF ATTORNEY", docName: "docPoa", sourceId: 1224 },
  { index: 5, title: "ADMIN OF ESTATES", docName: "docAoe", sourceId: 1225 },
  { index: 6, title: "ITEMIZED RECEIPTS", docName: "docIr", sourceId: 1226 },
  { index: 7, title: "OTHER", docName: "docOther", sourceId: 1227 }
];
const DeathIntake = (props) => {
  const {
    documentFields,
    sourceName = "DI",
    documentSources,
    uploadedDocumentAttechment,
    open,
    fullWidth,
    modalTitle = "",
    maxWidth = "md",
    handleClose,
    // referenceId,
    loading,
    documentReferenceId,
    attachmentId = null,
    isShowClosed = false,
    employeeId = null,
    docSelectionON = false,
    approvalBtn = false,
  } = props;
  const classes = useStyles();

  const plan = {
    InsuranceList: [
      { value: "BASIC", label: "BASIC" },
      { value: "ADDITIONAL", label: "ADDITIONAL" },
      { value: "DEPENDENT", label: "DEPENDENT" },
      { value: "REPATRIATION", label: "REPATRIATION" },
    ],
    ReceivedByList: [
      { value: "LPC", label: "LPC" },
      { value: "MRN", label: "MRN" },
      { value: "NCS", label: "NCS" },
      { value: "JDG", label: "JDG" },
      { value: "KSP", label: "KSP" },
      { value: "AMP", label: "AMP" },
      { value: "ADD", label: "ADD" },
    ],
    StatusList: [
      { value: "ACTIVE", label: "ACTIVE" },
      { value: "DB RETIREE", label: "DB RETIREE" },
      { value: "DC RETIREE", label: "DC RETIREE" },
      { value: "SURVIVOR", label: "SURVIVOR" },
      { value: "DEPENDENT", label: "DEPENDENT" },
    ],

    basic_plan: "Basic Life Insurance",
    basic_amount: "10000",
    basic_description: "Basic Life with AD&D $10,000 (Employer Paid) ",

    additional_plan: "Additional/Optional Life Insurance",
    additional_plan_decline: "Decline Additional/Optional Life with AD&D ",
    additional_amount: "10000",
    additional_description: "Basic Life with AD&D $10,000 (Employer Paid) ",
    additional_line1:
      "You may choose one of the following options for yourself:",
    additional_select:
      "Additional/Optional Life with AD&D (Employee Paid) (See Coverage Highlights for bi-weekly age-banded premium rates)",
    additional_amount: [
      { value: 30000, label: "$30,000" },
      { value: 35000, label: "$35,000" },
      { value: 40000, label: "$40,000" },
      { value: 45000, label: "$45,000" },
      { value: 50000, label: "$50,000" },
      { value: 55000, label: "$55,000" },
      { value: 60000, label: "$60,000" },
      { value: 65000, label: "$65,000" },
      { value: 70000, label: "$70,000" },
      { value: 75000, label: "$75,000" },
      { value: 80000, label: "$80,000" },
      { value: 85000, label: "$85,000" },
      { value: 90000, label: "$90,000" },
      { value: 95000, label: "$95,000" },
      { value: 100000, label: "$100,000" },
      { value: 105000, label: "$105,000" },
      { value: 110000, label: "$110,000" },
      { value: 115000, label: "$115,000" },
      { value: 120000, label: "$120,000" },
      { value: 125000, label: "$125,000" },
      { value: 130000, label: "$130,000" },
    ],
    dependents_plan: "Dependents Life Insurance",
    dependents_amount: "18000",
    dependents_decline: "Decline Spouse Life / Child(ren) Life",
    dependents_description:
      "Spouse Life $10,000 / Child(ren) Life $8,000 (Employee Paid) (See Coverage Highlights for bi-weekly premiums)",
  };

  const basicInsurance = {
    Name: "",
    relation: "",
    ssn: "",
    gender: "",
    dob: "",
    mailingAddress: "",
    email: "",
    contact: "",
  };
  const optionalInsurance = {
    Name: "",
    relation: "",
    ssn: "",
    gender: "",
    dob: "",
    mailingAddress: "",
    email: "",
  };

  const dependInsurance = {
    Name: "",
    relation: "",
    ssn: "",
    gender: "",
    dob: "",
    mailingAddress: "",
    email: "",
  };

  const { id } = useParams()
  const [selectedValue, setSelectedValue] = useState(null);
  const [basicDependent, setBasicDependant] = useState([basicInsurance]);
  const [additionInsurance, setAdditionInsurance] = useState([
    optionalInsurance,
  ]);
  const [dependentInsurance, setDependentInsurance] = useState([
    dependInsurance,
  ]);
  const [deletedDependent, setdeletedDependent] = useState([]);
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const fileInputs = useRef([]);
  const [selectedOptions, setSelectedOptions] = useState(null);

  //pdf
  const [options, setOptionsList] = useState([]);
  const [docSelectedID, setDocSelectedID] = useState(null);
  const [isDocumentViewer, setIsDocumentViewer] = useState(false);
  const [documentFile, setDocumentFile] = useState(null);
  const [documentTitle, setDocumentTitle] = useState(null);
  const [getdocument, setDocument] = useState();
  const [referenceId, setReferenceId] = useState();

  // useEffect(() => {
  //   const generateRandomNumber = () => Math.floor(Math.random() * 100) + 100000000; // Generates a number between 1 and 100
  //   setReferenceId(generateRandomNumber());
  // }, []);

  const handleOpen = (documentFile, filename) => {
    setIsDocumentViewer(true);
    setDocumentFile(documentFile);
    setDocumentTitle(filename);
    console.log("vdsdsdfdfdsf", documentFile, filename);
  };

  const documentsouceDependency = useMemo(() => {
    if (documentSources.length) {
      return JSON.stringify(documentSources);
    } else {
      return "";
    }
  }, [documentSources]);

  useEffect(() => {
    if (!!documentSources.length && sourceName) {
      handleOptionChange(
        documentSources?.find((item) => item?.sourceName === sourceName).id
      );
      props?.getDocumentFields({
        sourceID: documentSources.find(
          (item) => item?.sourceName === sourceName
        ).id,
      });
    }
  }, [documentsouceDependency]);

  useEffect(() => {
    handleReset();
    if (!sourceName) {
      handleOptionChange(null);
      setOptionsList([]);
    }
  }, [open]);

  const handleReset = () => {
    setUploadFiles([]);
    reset();
  };

  useEffect(() => {
    if (
      !!documentSources.length &&
      !!uploadedDocumentAttechment?.uploadedDocuments?.length
    ) {
      const obj = {
        [documentSources?.find((item) => item?.sourceName === sourceName)
          ?.sourceName + "documentattachment"]: documentSources?.find(
            (item) => item?.sourceName === sourceName
          )?.sourceName,
        "uploadedDocument": uploadedDocumentAttechment,
      };

      localStorage.setItem(
        "uploadedUpdateDocumentAttechment",
        JSON.stringify(obj)
      );

      handleClose();
    }
  }, [uploadedDocumentAttechment]);

  const handleOptionChange = (option) => {
    handleReset();
    !!option ? setSelectedOptions(option) : setSelectedOptions(null);
    if (option) {
      props?.getDocumentFields({ sourceID: option });
    } else {
      props?.getDocumentFields({ sourceID: -1 });
    }
    setValue("selectSource", option);
  };
  //pdf

  const addTrailingZeros = (inputString) => {
    const length = Number(inputString).toString().length;
    if (length >= 11) {
      return inputString;
    }
    const numberOfZerosToAdd = 11 - length;
    const zeros = "0".repeat(numberOfZerosToAdd);
    return zeros + inputString;
  };

  console.log("Dasdadaa", basicDependent);
  console.log("value", values);

  const handleCheckboxChange = (value) => {
    setSelectedValue(value);
    // console.log(value)
  };

  const [expanded, setExpanded] = React.useState({
    empDetail: true,
    healthandDeduction: true,
    dependent: true,
    familyInfo: true,
    document: true,
    process: true,
    notice: true,
  });

  const { handleSubmit, control, reset, setValue, register } = useForm({});

  const handleChangeExpanded = (panel) => (event, isExpanded) => {
    setExpanded((prevState) => ({
      ...prevState,
      [panel]: isExpanded,
    }));
  };

  //pdf
  const { userData } = useAuth();

  const [show, setShow] = useState(true);
  const [loding, setLoading] = useState(false);
  const [defaultOpen, setDefaultOpen] = useState(true);

  const [myschema, setMySchema] = useState({
    required: [
      {
        field: "",
        msg: "",
        length: "",
      },
    ],
  });
  const fileIcons = {
    pdf: faFilePdf,
    doc: faFileWord,
    docx: faFileWord,
    xls: faFileExcel,
    xlsx: faFileSpreadsheet,
    csv: faFileCsv,
    txt: faFileLines,
    png: faFileImage,
    jpg: faFileImage,
    jpeg: faFileImage,
    gif: faFileImage,
    ppt: faFilePowerpoint,
  };

  useEffect(() => {
    props?.getDocumentSources();
  }, []);

  const [uploadFiles, setUploadFiles] = useState([]);

  const handleUploadChange = (e, index, attachmentId, names) => {
    console.log("DocSelectedID", e, attachmentId);
    console.log("docu", documentSources);
    const file = e;
    if (!file || (file && file?.url)) return;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    const mainname = names == "BIRTH CERTIFICATE– FOR DEPENDENT COVERAGE (STEPCHILD)" ? "BCDC" : names
    reader.onloadend = () => {
      const updatedUploadFiles = [...uploadFiles];
      const payload = {
        DocumentFile: reader.result.toString(),
        FileName: `${mainname}-${e.type}-${addTrailingZeros(
          attachmentId
        )}-${new Date()
          .toLocaleString("en-GB")
          .replace(/\s/g, "")
          .split(",")
          .join("-")}.${file?.name.split(".").pop()}`,
        attachmentId: attachmentId,
      };
      updatedUploadFiles[index] = payload;
      setUploadFiles(updatedUploadFiles);
      setValue(
        `documentAttachmentReqDTOs[${index}].documentUrl`,
        payload?.DocumentFile
      );
      setValue(
        `documentAttachmentReqDTOs[${index}].documentName`,
        payload?.FileName
      );
      setValue(
        `documentAttachmentReqDTOs[${index}].sourceId`,
        documentSources?.find((item) => item.id == selectedOptions)?.id
      );
      setValue(
        `documentAttachmentReqDTOs[${index}].attachmentId`,
        payload?.attachmentId
      );
      setValue(`documentAttachmentReqDTOs[${index}].employeeId`, employeeId);
      updatedUploadFiles[index].DocumentFileAsBinary =
        URL.createObjectURL(file);
      if (referenceId || documentReferenceId) {
        setValue(
          `documentAttachmentReqDTOs[${index}].referenceId`,
          referenceId || documentReferenceId
        );
      }
    };
    reader.onerror = () => {
      console.log("error on load document");
    };
  };

  const getIconForExtension = (extension) => {
    return fileIcons[extension] || faFileLines;
  };

  const getFileExtension = (fileName) => {
    return fileName.split(".").pop().toLowerCase();
  };


  const removedocument = (id, newArray, index) => {
    axios.delete(
      `${process.env.REACT_APP_API_DOTNET_URL}DocumentAttachment/${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem(
            "jwt_access_token"
          )}`,
        },
      }
    ).then((response) => {
      console.log("ressssssss", uploadFiles)
      ShowSucess("Document remove Successfully");
      Documentglobal(referenceId)
      newArray[index] = null;
      setUploadFiles(newArray);
      setValue(`documentAttachmentReqDTOs`, newArray);
    }).catch((err) => {
      console.log("err")
      // ShowError("Internal Server Error !");
    })
  }


  const handleDelete = (index, docName, currentDocument) => {
    const newArray = [...uploadFiles];
    const indexToRemove = newArray[index];
    if (indexToRemove) {
      newArray[index] = null;
      setUploadFiles(newArray);
      setValue(`documentAttachmentReqDTOs`, newArray);
    }
    console.log("dfdddddfdf", currentDocument)
    if (currentDocument && currentDocument.ID) {
      removedocument(currentDocument.ID, newArray, index)
    }
    console.log("dodfddfdfdf", docName)
    setValues((prevValues) => ({
      ...prevValues,
      [docName]: "",
      [`${docName}Date`]: ""
    }));
  };

  //pdf

  useEffect(() => {
    if (
      userData?.profile?.DOB &&
      userData?.profile?.EmployeeID &&
      userData?.profile?.LastName &&
      userData?.profile?.SSN
    ) {
      // setLoading(true);
      // searchEmployeeAPI(
      //   userData?.profile?.DOB,
      //   userData?.profile?.SSN,
      //   userData?.profile?.LastName,
      //   userData?.profile?.EmployeeID
      // );
      setValues({
        ...values,
        DOB: userData?.profile?.DOB,
        employee_no: userData?.profile?.EmployeeID,
        last_name: userData?.profile?.LastName,
        ssn: userData?.profile?.SSN,
      });
    }
  }, [userData]);

  const handleUpdatePlan = () => {
    if (values?.UID && values?.healthPlan && values?.HealthVendor) {
      setLoading(true);
      const payload = {
        uid: values?.UID,
        healthVendor: values?.HealthVendor,
        healthPlan: values?.healthPlan,
        healthDeductionClass: values?.healthDeductionClass,
      };
      axios
        .put(
          `${process.env.REACT_APP_API_DOTNET_URL}/BenefitsMASTER/update`,
          [{ ...payload }],
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem(
                "jwt_access_token"
              )}`,
            },
          }
        )
        .then((response) => {
          setLoading(false);
          ShowSucess("Successfully Updated.");
        })
        .catch((error) => {
          setLoading(false);
          ShowError("Internal Server Error !");
        });
    } else {
      ShowError("Please select any health plan");
    }
  };

  const getDependentList = async (employeeId) => {
    try {
      const getDependent = await axios.get(
        `${process.env.REACT_APP_API_DOTNET_URL}/BenefitsMASTER/GetBySubscriberId?SubscriberId=${employeeId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          },
        }
      );
      // setDependentInformation(
      //   getDependent.data.length > 1
      //     ? getDependent.data.filter((i) => i.employeeId !== i.subscriberId)
      //     : [
      //         {
      //           ...initialDependent,
      //           subscriberId: employeeId,
      //           email: values?.email,
      //           mailingAddress: values?.mailingAddress,
      //           lastName: values?.last_name,
      //         },
      //       ]
      // );
    } catch (error) {
      // setDependentInformation([
      //   {
      //     ...initialDependent,
      //     subscriberId: employeeId,
      //     email: values?.email,
      //     mailingAddress: values?.mailingAddress,
      //     lastName: values?.last_name,
      //   },
      // ]);
    }
    setdeletedDependent([]);
  };

  const urlValue = useParams();


  const saveDocumentFiles = async (index, documentname, url, DocumentFileAsBinary, docName, label, sourceId) => {


    const data = {
      attachmentId: sourceId,
      documentName: documentname,
      documentUrl: `${url}`,
      "remarks": "",
      // DocumentFileAsBinary:DocumentFileAsBinary,
      "employeeId": null,
      referenceId: referenceId,
      sourceId: 42
    };
    console.log("Datamafjdifdfd", data);
    console.log("Uploaded files", uploadFiles);
    const now = new Date();
    const formattedDate = format(now, "MM/dd/yyyy hh:mm:ss a");
    console.log("formattedDate", formattedDate)
    // setValues((prevValues) => ({
    //   ...prevValues,
    //   [docName]: data,
    //   [`${docName}Date`]:`${formattedDate}`
    // }));
    setLoading(true)
    axios.post(
      `${process.env.REACT_APP_API_DOTNET_URL}/DocumentAttachment/UploadDocumentAttachment`,
      { sourceName: "DI", documentAttachmentReqDTOs: [data] },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem(
            "jwt_access_token"
          )}`,
        },
      }
    ).then((response) => {
      console.log("ressssssss", response)
      ShowSucess("Document Updated Successfully");
      Documentglobal(referenceId)
      setLoading(false)
      setValues((prevValues) => ({
        ...prevValues,
        [docName]: data,
        [`${docName}Date`]: `${formattedDate}`
      }));
    }).catch((err) => {
      console.log("err")
      ShowError("Internal Server Error !");
      setLoading(false)
    })
  };


  const Documentglobal = (newid) => {

    const payload = {
      "tableName": "fn_getDocumentAttachmentByReference",
      "searchParams": `[{\"columnName\":\"ReferenceID\",\"operator\":\"=\",\"value\":"${newid}",\"dataType\":\"varchar(max)\",\"logicOperator\":\"AND\"}]`,
      "columns": "*",
      "pageNumber": 1,
      "pageSize": 100,
      "sortData": "",
      "additionalWhere": `IsDeleted = 0`,
      "qID": 0,
      "role": "",
      "location": "global",
      "id": "fn_getDocumentAttachmentByReference"
    }

    axios.post(
      `${process.env.REACT_APP_API_DOTNET_URL}/BenefitAdvanceSearch/Benefits-global`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          Role: getUserRole(userData),
        },
      }
    ).then((res) => {


      setDocument(res.data.results)
      if (res.data.results.length > 0) {
        let docdata = res.data.results;
        let updatechk = checkedStates;

        documents.map((l) => {
          // l.AttachmentId==l.sourceId
          if (docdata.find((k) => k.AttachmentId == l.sourceId)) {
            updatechk[l.index] = true;
          } else {
            updatechk[l.index] = false;
          }
        })
        setCheckedStates([...updatechk]);
      }
    }).catch((err) => {
      console.log(err)
      setCheckedStates(Array(8).fill(false));
    })
  }

  useEffect(() => {
    const newid = id ? `DI-${id}` : ("DI-A" + Math.floor(Math.random() * 100) + 100000000)
    Documentglobal(newid)
    setReferenceId(newid)
  }, [id])

  // const searchEmployeeAPI = async (
  //   DOB = null,
  //   ssn = null,
  //   last_name = null,
  //   employee_no = null
  // ) => {
  //   axios
  //     .get(
  //       `${process.env.REACT_APP_API_DOTNET_URL}/BenefitsMASTER/${moment(
  //         DOB
  //       ).format("YYYY-MM-DD")}/${ssn}/${last_name}/${employee_no}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
  //         },
  //       }
  //     )
  //     .then(async (res) => {
  //       const resData = res?.data?.length ? res?.data[0] : {};
  //       if (Object.keys(resData).length) {
  //         await getDependentList(resData.employeeId);
  //         // setShow(true);

  //         let searchData = {
  //           UID: resData?.uid,
  //           id: resData?.id,
  //           employee_no: resData?.employeeId,
  //           subscriberId: resData?.subscriberId,
  //           Employeetype: resData?.employeeType,
  //           HealthVendor: resData?.healthVendor,
  //           healthPlan: resData?.healthPlan,
  //           healthDeductionClass: resData?.healthDeductionClass,
  //           email: resData?.email,
  //           lastName: resData?.lastName,
  //           mailingAddress: resData?.mailingAddress,
  //           firstName: resData?.firstName,
  //           dob: resData?.dob,
  //           city: resData?.city,
  //           zip: resData?.zip,
  //           homePhone: resData?.homePhone,
  //           state: resData?.state,
  //           gender: resData?.gender,
  //           dateOfEmployment: resData?.dateOfEmployment
  //             ? moment(resData?.dateOfEmployment).format("YYYY-MM-DD")
  //             : null,
  //         };
  //         setValues((state) => {
  //           return { ...state, ...searchData };
  //         });
  //         setSelectedValue(resData?.gender);
  //       } else {
  //         ShowError("Employee Not Found !");
  //       }
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //       ShowError("Employee Not Found !");
  //     });
  // };


  const navigat = useNavigate()
  const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;
  const getData = (id) => {
    const payload = {
      // tableName: "vw_AllTransaction_emp_portal",
      tableName: "Benefits_Death_Intake",
      SearchParams: "",
      columns: "*",
      pageNumber: 1,
      pageSize: 10000000,
      orderBy: "ID DESC",
      sortBy: "",
      orderByMultiple: "",
      limit: 10000000000,
      sortData: "",
      additionalWhere: `ID = ${id}`,
    };
    axios
      .post(`${newBaseURL}/BenefitAdvanceSearch/Benefits-global`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          Role: getUserRole(userData),
        },
      })
      .then((response) => {
        const intackdata = response?.data?.results[0]
        const intack = {
          "id": intackdata?.ID,
          "dependentId": intackdata?.DependentID,
          "dependType": intackdata?.DependType,
          "receivedby": intackdata?.RecBy,
          "reportedDate": intackdata?.ReportedDate,
          "reportedBy": intackdata?.ReportedBy,
          "decName": intackdata?.Dec_Name,
          "decStatus": intackdata?.Dec_Status,
          "decDept": intackdata?.Dec_Dept,
          "decDob": intackdata?.Dec_DOB,
          "decSsn": intackdata?.Dec_SSN,
          "decDod": intackdata?.Dec_DOD,
          "decDeathPlace": intackdata?.Dec_Death_Place,
          "decResidencePlace": intackdata?.Dec_Residence_Place,
          "decNextOfKin": intackdata?.Dec_Next_Of_Kin,
          "decSpouseCil": intackdata?.Dec_Spouse_Cil,
          "decSpouseCilDept": intackdata?.Dec_Spouse_Cil_Dept,
          "dependPolicyHolder": intackdata?.Depend_Policy_Holder,
          "dependSsn": intackdata?.Depend_SSN,
          "dependStatus": intackdata?.Depend_Status,
          "dependDob": intackdata?.Depend_DOB,
          "dependDept": intackdata?.Depend_DEPT,
          "docDc": "",
          "docDcDate": "",
          "docFdq": "",
          "docFdqDate": "",
          "docMc": "",
          "docMcDate": "",
          "docBcdc": "",
          "docBcdcDate": "",
          "docPoa": "",
          "docPoaDate": "",
          "docAoe": "",
          "docAoeDate": "",
          "docIr": "",
          "docIrDate": "",
          "docOther": "",
          "docOtherDate": "",
          "proceHealthInsu": intackdata?.Proce_Health_Insu == true ? "true" : "false",
          "proceHelathSubDepen": intackdata?.Proce_Helath_Sub_Depen == true ? "true" : "false",
          "ProceLifeInsu": intackdata?.Proce_Life_Insu == true ? "true" : "false",
          "ProceLifeDepenEligible": intackdata?.Proce_Life_Depen_Eligible == true ? "true" : "false",
          "proceLifeSpouse": intackdata?.Proce_Life_Spouse == true ? "true" : "false",
          "notes": intackdata?.Notes,
          "proceLifeDepenEligibleStatus": intackdata?.proceLifeDepenEligibleStatus,
          "proceLifeSpouseStatus": intackdata?.proceLifeSpouseStatus,
          "familyInfo": intackdata?.FamilyInfo
            ? JSON.parse(intackdata?.FamilyInfo)
            : [],
        }
        setValues({ ...values, ...intack });
        if (intack?.familyInfo?.length) {
          setBasicDependant(intack?.familyInfo);
        }
        if (!intackdata?.ID) {
          navigat("/death-intake")
        }
        setReferenceId(`DI-${intackdata?.ID}`)
        // const { results, rowCount } = response?.data;
        // console.log("Dsadddada", results, rowCount);
        // setData(results);
        // setRowCount(rowCount);
        // setLoading(false)
      })
      .catch((error) => {
        setLoading(false);
      });


  }

  useEffect(() => {
    if (id) {
      getData(id)
    }
  }, [id])


  const onSubmit = (e) => {
    // API Calling
    // setLoading(true);
    // searchEmployeeAPI(
    //   values?.DOB,
    //   values?.ssn,
    //   values?.last_name,
    //   values?.employee_no
    // );
  };

  const handleDependentUpdate = async () => {
    if (
      basicDependent.some(
        (i) =>
          !i.firstName ||
          !i.lastName ||
          !i.middleName ||
          (i.uid ? false : !i.ssn || i["ssn"].length != 9) ||
          (values?.healthDeductionClass != "I" && !i.relation) ||
          !i.gender ||
          !i.dob
      )
    ) {
      ShowError("Please Check Dependent Information");
      return false;
    }

    setLoading(true);

    axios
      .post(
        `${process.env.REACT_APP_API_DOTNET_URL}/BenefitsMASTER/CreateOrUpdateDeteteBenefits`,
        {
          createnupdate: [
            ...basicDependent.map((i) => {
              i?.uid && delete i.ssn;
              return i;
            }),
            ...[
              {
                uid: values?.UID,
                healthVendor: values?.HealthVendor,
                healthPlan: values?.healthPlan,
                healthDeductionClass: await setClassValues(basicDependent),
                subscriberId: values?.subscriberId,
                id: values?.id,
              },
            ],
          ],
          deletedList: deletedDependent,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          },
        }
      )
      .then(async (response) => {
        await getDependentList(values?.employee_no);
        ShowSucess("Successfully Updated.");
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleBasicInsuranceDelete = (uid) => {
    setdeletedDependent([...deletedDependent, uid]);
  };

  const handleAdditionalInsuranceDelete = (uid) => {
    setdeletedDependent([...deletedDependent, uid]);
  };
  const handleDependentInsuranceDelete = (uid) => {
    setdeletedDependent([...deletedDependent, uid]);
  };

  // const values = {};
  // const setValues = {};
  // const errors = {};

  const setFieldValue = {};
  const uniquevalues = {};

  // const {
  //   values,
  //   errors,
  //   touched,
  //   handleBlur,
  //   handleChange,
  //   handleSubmit,
  //   setFieldValue,
  //   validateForm,
  //   setValues,
  // } = useFormik({
  //   initialValues: initialItem,
  //   validationSchema: Yup.object().shape(schema),
  //   onSubmit,
  // });

  const renderGroupCheckbox = (
    size = "large",
    stateName,
    value,
    other = null
  ) => {
    let defaultChk = (
      <Checkbox
        size={size}
        checked={values[stateName] == value}
        onChange={(e) => {
          setFieldValue(stateName, value);
        }}
      />
    );
    if (other && other.matchkey && other.matchkey1) {
      defaultChk = (
        <Checkbox
          size={size}
          checked={
            values[stateName] == value &&
            values[other.matchkey] == other.matchvalue &&
            values[other.matchkey1] == other.matchvalue1
          }
          disabled={other?.disabled ? other?.disabled : false}
          onChange={(e) => {
            if (
              stateName == "healthDeductionClass" &&
              other?.changeTarget1 &&
              other?.changeTarget1 == "HealthVendor" &&
              other?.changeTarget2 == "healthPlan"
            ) {
              setFieldValue(other?.changeTarget1, other?.changeTargetValue1);
              setFieldValue(other?.changeTarget2, other?.changeTargetValue2);
              // setFieldValue("amount", other?.amount);
            }

            setFieldValue(stateName, value);
          }}
        />
      );
    } else if (other && other.matchkey) {
      defaultChk = (
        <Checkbox
          size={size}
          checked={
            values[stateName] == value &&
            values[other.matchkey] == other.matchvalue
          }
          disabled={other?.disabled ? other?.disabled : false}
          onChange={(e) => {
            if (
              stateName == "healthDeductionClass" &&
              other?.changeTarget1 &&
              other?.changeTarget1 == "HealthVendor" &&
              other?.changeTarget2 == "healthPlan"
            ) {
              setFieldValue(other?.changeTarget1, other?.changeTargetValue1);
              setFieldValue(other?.changeTarget2, other?.changeTargetValue2);
            }
            if (stateName == "healthPlan" && other.matchkey) {
              setFieldValue(
                "healthDeductionClass",
                values?.healthDeductionClass
              );
            }
            setFieldValue(stateName, value);
          }}
        />
      );
    } else {
      defaultChk = (
        <Checkbox
          size={size}
          checked={values[stateName] == value}
          onChange={(e) => {
            setFieldValue(stateName, value);
          }}
        />
      );
    }
    return defaultChk;
  };
  const renderCheckbox1 = (index, size = "large", stateName, value) => {
    return (
      <Checkbox
        size={size}
        checked={values[stateName] === value}
        onChange={(e) => {
          setValues({ ...values, [stateName]: e.target.checked ? value : "" });
        }}
      />
    );
  };

  const [showPassword, setShowPassword] = useState(false);

  const [showPasswordsecond, setShowPasswordsecond] = useState(false);
  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const handleTogglePasswordSecond = () => {
    setShowPasswordsecond(!showPasswordsecond);
  };

  const handleChanges = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.value,
    });
  };

  function renderTextInput(stateName, label, others = {}, endAdornment = null) {
    let other = {
      disabled: false,
      maxLength: "",
      multiline: false,
      shrink: true,
      ...others,
    };
    let {
      disabled,
      maxLength,
      multiline,
      type,
      required = false,
      shrink,
      pattern,
    } = other;

    return (
      <TextField
        fullWidth
        size="small"
        inputProps={{
          style: {
            fontSize: "14px",
            paddingTop: "12px",
            width: "100%",
          },
          readOnly: disabled,
          maxLength: maxLength,
          pattern: pattern,
        }}
        margin="dense"
        variant="outlined"
        label={label}
        name={stateName}
        type={type}
        id={stateName}
        multiline={multiline}
        rows={multiline ? 5 : 1}
        value={values[stateName]}
        InputLabelProps={{
          shrink: shrink ? shrink : false,
          classes: { asterisk: required ? classes.asterisk : false },
        }}
        InputProps={{
          endAdornment: endAdornment,
        }}
        onChange={(e) => {
          if (!disabled) {
            handleChanges(e);
          }
        }}
        error={!disabled && errors[stateName]}
        disabled={disabled}
        required={required}
      />
    );
  }

  const [checkedStates, setCheckedStates] = useState([]);
  const renderCheckbox3 = (index, size = 'large', stateName, value, currentDocument, checkedStates, setCheckedStates) => {
    return (
      <Checkbox
        size={size}
        checked={(checkedStates[index]) ? true : false}
        onChange={(e) => {
          const newCheckedStates = [...checkedStates];
          console.log("dfdfdsdssdf", [...checkedStates], '###N##', values?.[stateName], 'VVV', values?.[stateName]?.documentName)
          let updateobj = { ...newCheckedStates[index] };
          updateobj = e.target.checked;

          newCheckedStates[index] = updateobj;
          setValue(values?.[stateName], '')
          // console.log("newCheckedStates",newCheckedStates)
          // checkedStates[index] = e.target.checked;
          setCheckedStates(newCheckedStates);
          const newArray = [...uploadFiles];
          newArray[index] = null;
          setUploadFiles(newArray);
          setValue(`documentAttachmentReqDTOs`, newArray);
          if (currentDocument && currentDocument.ID) {
            setValue(values?.[stateName], '')
            setValue(stateName, '')
            removedocument(currentDocument.ID, newArray, index)
          }
          // setValues((prevValues) => ({
          //   ...prevValues,
          //   [stateName]: "",
          //   [`${stateName}Date`]: ""
          // }));
          // }
        }}
      />
    );
  };


  const renderUploadSection = (index, label, docName, sourceId, checkedStates) => {
    const documentData = getdocument?.filter((i) => i.AttachmentId === sourceId) || [];
    const currentDocument = documentData[0] || {};

    console.log("documentdfdzczxvcvczxvcxv", currentDocument)
    const isCurrentDocumentAvailable = currentDocument && currentDocument.DocumentName && currentDocument.DocumentURL;

    if (isCurrentDocumentAvailable && !uploadFiles[index]) {
      uploadFiles[index] = {
        FileName: currentDocument.DocumentName,
        DocumentFileAsBinary: currentDocument.DocumentURL
      };
      console.log("dfdfdsaregregre", uploadFiles[index])
    }

    // Ensure the checkbox is checked if there's a currentDocument
    if (isCurrentDocumentAvailable) {
      // checkedStates[index] = true;
    }

    console.log("Filtered Document Data:", uploadFiles);
    return (
      <Row style={{ marginBottom: "10px" }}>
        <Col style={{ display: "flex", alignItems: "center" }}>
          {renderCheckbox3(index, "medium", docName, label, currentDocument, checkedStates, setCheckedStates)} {label}
        </Col>
        <Col style={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
          <Col style={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
            {!uploadFiles[index] || !uploadFiles[index].FileName ? (
              <div style={{ alignItems: "end" }}>
                <Grid
                  className="d-flex justify-content-end align-items-center mt-2"
                  item
                  xs={12}
                  md={5}
                >
                  <Button
                    style={{ color: "white", cursor: "pointer" }}
                    variant="fill"
                    className="btn btn-primary"
                    fullWidth
                    size="large"
                    color="primary"
                    onClick={() => fileInputs.current[index].click()}
                    disabled={!checkedStates[index]}
                  >
                    Select Document
                  </Button>

                  <input
                    {...register(
                      `documentAttachmentReqDTOs[${index}].documentUrl`,
                      {
                        required: true,
                        validate: {
                          isPDF: (value) => {
                            if (value) {
                              return (
                                value?.match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/)[0] ===
                                "application/pdf" ||
                                "Only PDF files are allowed"
                              );
                            } else {
                              return true;
                            }
                          },
                        },
                      }
                    )}
                    ref={(el) => (fileInputs.current[index] = el)}
                    accept="application/pdf"
                    className="hidden"
                    name={`documentAttachmentReqDTOs[${index}].documentUrl`}
                    onChange={(event) => {
                      handleUploadChange(
                        event.target.files[0],
                        index,
                        docSelectedID,
                        label
                      );
                    }}
                    type="file"
                  />
                </Grid>
              </div>
            ) : (
              <Grid
                className="d-flex justify-content-center align-items-center mt-2"
                item
                xs={12}
                md={12}
              >
                {uploadFiles[index] && uploadFiles[index].FileName && (
                  <Paper
                    elevation={4}
                    className={`${classes.fileItem} px-4`}
                    style={{ display: "flex", alignItems: "center", width: "300px" }}
                  >
                    <div style={{ display: "flex", alignItems: "center", width: "90%" }}>
                      <FontAwesomeIcon
                        className="fa-duotone font-primary"
                        icon={getIconForExtension(
                          getFileExtension(uploadFiles[index]?.FileName)
                        )}
                        size="2x"
                      />
                      <Typography
                        variant="body1"
                        className={`${classes.fileName} mx-2`}
                        style={{ fontSize: "10px" }}
                      >
                        {/* {uploadFiles[index].FileName} */}
                        {label}
                      </Typography>
                    </div>
                    <div style={{ width: "10%" }}>
                      <Tooltip title="Remove" arrow>
                        <IconButton
                          edge="end"
                          aria-label="remove"
                          onClick={() => handleDelete(index, docName, currentDocument)}
                        >
                          <HighlightOffIcon />
                        </IconButton>
                      </Tooltip>
                    </div>
                  </Paper>
                )}
              </Grid>
            )}
            <Grid
              className="d-flex justify-content-center align-items-center px-3"
              item
              xs={12}
              md={12}
            >
              {errors?.documentAttachmentReqDTOs && (
                <span style={{ color: "red" }}>
                  {errors.documentAttachmentReqDTOs[index]?.documentUrl?.message}
                </span>
              )}
            </Grid>
            <Grid
              className="d-flex justify-content-center align-items-center"
              item
              xs={12}
              md={1}
            >
              {uploadFiles[index] && uploadFiles[index].FileName && (
                <Tooltip title="View Document" style={{ display: "flex" }} arrow>
                  <IconButton
                    edge="end"
                    aria-label="remove"
                    style={{ marginRight: "12px" }}
                    onClick={() =>
                      handleOpen(
                        uploadFiles[index].DocumentFileAsBinary,
                        uploadFiles[index].FileName
                      )
                    }
                  >
                    <Visibility />
                  </IconButton>
                  <Button
                    style={{ color: "white", cursor: "pointer" }}
                    variant="fill"
                    className="btn btn-primary"
                    fullWidth
                    size="large"
                    color="primary"
                    disabled={values[docName] || currentDocument.AttachmentId == sourceId}
                    onClick={() =>
                      saveDocumentFiles(
                        index,
                        uploadFiles[index].FileName,
                        uploadFiles[index].DocumentFile,
                        uploadFiles[index].DocumentFileAsBinary,
                        docName,
                        label,
                        sourceId
                      )
                    }
                  >
                    Save
                  </Button>
                </Tooltip>
              )}
            </Grid>
          </Col>
        </Col>
      </Row>
    );
  };



  function renderDateInput(
    stateName,
    label,
    disabled = false,
    minDate = null
    // maxDate
  ) {
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DesktopDatePicker
          inputVariant={"outlined"}
          margin="dense"
          format="MM/dd/yyyy"
          label={label}
          minDate={minDate}
          // maxDate={maxDate}
          value={values[stateName] ? values[stateName] : null}
          KeyboardButtonProps={{ "aria-label": label }}
          disabled={disabled}
          onChange={(value) => {
            const formatDate = value?.$d;
            const date = formatDate
              ? moment(formatDate).format("YYYY-MM-DD")
              : null;
            // setShow(false);
            console.log("Dasdasdsadaa", date);
            // setFieldValue(stateName, date);
            setValues({ ...values, [stateName]: date });
          }}
          // onBlur={handleBlur}
          renderInput={(params) => (
            <TextField
              fullWidth
              margin="dense"
              size="small"
              InputLabelProps={{ shrink: true }}
              {...params}
              error={!disabled && errors[stateName]}
            // helperText={!disabled && errors[stateName]}
            />
          )}
        />
      </LocalizationProvider>
    );
  }

  function renderDateTimeInput(
    stateName,
    label,
    disabled = false,
    minDate = null
    // maxDate
  ) {
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DesktopDateTimePicker
          inputVariant="outlined"
          margin="dense"
          format="MM/DD/YYYY hh:mm A"
          label={label}
          minDate={minDate}
          // maxDate={maxDate}
          value={values[stateName] ? dayjs(values[stateName]) : null}
          KeyboardButtonProps={{ 'aria-label': label }}
          disabled={disabled}
          onChange={(value) => {
            const formatDate = value?.toDate();
            const dateTime = formatDate
              ? dayjs(formatDate).format('YYYY-MM-DD hh:mm:ss A')
              : null;
            console.log('Selected DateTime:', dateTime);
            setValues({ ...values, [stateName]: dateTime });
          }}
          renderInput={(params) => (
            <TextField
              fullWidth
              margin="dense"
              size="small"
              InputLabelProps={{ shrink: true }}
              {...params}
              error={!disabled && errors[stateName]}
            />
          )}
        />
      </LocalizationProvider>
    );
  }

  function renderDropDown(stateName, label, value, disabled) {
    return (
      <div>
        <TextField
          margin="dense"
          className="flex w-full  mt-2"
          variant="outlined"
          select
          SelectProps={{ native: true }}
          style={{ width: "100%" }}
          size="small"
          disabled={disabled}
          inputProps={{
            style: {
              fontSize: "14px",
              color: "black",
              paddingTop: "12px",
            },
          }}
          label={label}
          name={stateName}
          InputLabelProps={{ shrink: true }}
          onChange={(e) => {
            handleChange(e);
          }}
          error={!disabled && errors[stateName]}
          helperText={!disabled && errors[stateName]}
          value={values[stateName]}
        >
          {/* <option value={""} disabled> */}
          {/* value={values[stateName]}> */}
          <option value={""} disabled>
            Select {label}
          </option>

          {value.length &&
            value.map((option) => (
              <option key={option.value} value={option.value}>
                {option.name}
              </option>
            ))}
        </TextField>
      </div>
    );
  }

  const renderCheckbox = (size = "large", stateName, value) => {
    return (
      <Checkbox
        size={size}
        checked={values[stateName] == value}
        onChange={(e) => {
          setFieldValue(stateName, value);
        }}
      />
    );
  };

  const setAmount = (currentClass) => {
    let getAmount = companyArray
      .find((item) => item.vendor_name == values?.HealthVendor)
      ?.vendor_items.find((item) => item.vendor_code == values?.healthPlan)
      ?.classInfo.find((ite) => ite.value == currentClass)?.amount;
    setFieldValue("amount", getAmount);
  };

  const setClassValues = async (dependentArray) => {
    const uniqueValues = [
      ...new Set(dependentArray.map((obj) => obj.relation)),
    ];

    if (uniquevalues?.every((i) => i == "")) {
      if (values?.healthDeductionClass != "I") {
        setAmount("I");
        ShowSucess(`Class changed ${values?.healthDeductionClass} to I `);
        setFieldValue("healthDeductionClass", "I");
      }
      return "I";
    }
    if (
      uniquevalues?.length == 1
        ? uniquevalues?.every((i) => ["spouse", "domesticpartner"].includes(i))
        : uniquevalues?.every(
          (i) => ["spouse", "domesticpartner"].includes(i) || i == ""
        )
    ) {
      if (values?.healthDeductionClass != "II") {
        setAmount("II");
        ShowSucess(`Class changed ${values?.healthDeductionClass} to II `);
        setFieldValue("healthDeductionClass", "II");
      }
      return "II";
    }
    if (
      uniquevalues?.length == 1
        ? uniquevalues?.every((i) => ["child"].includes(i))
        : uniquevalues?.every((i) => i == "child" || i == "")
    ) {
      if (values?.healthDeductionClass != "III") {
        setAmount("III");
        ShowSucess(`Class changed ${values?.healthDeductionClass} to III`);
        setFieldValue("healthDeductionClass", "III");
      }
      return "III";
    }
    if (
      uniquevalues?.length == 1
        ? uniquevalues?.some((i) =>
          ["spouse", "domesticpartner"].includes(i)
        ) && uniquevalues?.some((i) => ["child"].includes(i))
        : uniquevalues?.some(
          (i) => ["spouse", "domesticpartner"].includes(i) || i == ""
        ) && uniquevalues?.some((i) => ["child"].includes(i))
    ) {
      if (values?.healthDeductionClass != "IV") {
        setAmount("IV");
        ShowSucess(`Class changed ${values?.healthDeductionClass} to IV `);
        setFieldValue("healthDeductionClass", "IV");
      }
      return "IV";
    }
  };

  const getDateDifference = () => {
    const currentYear = moment().year();
    const defaultDate = moment(`09-30`, "MM-DD").year(currentYear);
    const currentDate = moment().year(currentYear);

    // Adjust the year for selectedDate if it is before constDate
    if (defaultDate.isBefore(currentDate)) {
      defaultDate.add(1, "year");
    }

    // Calculate the difference in days
    const diffDays = defaultDate.diff(currentDate, "days");

    return { diffDays, defaultDate, currentDate };
  };

  //HEALTH INSURANCE useEffect
  useEffect(() => {
    if (values.proceHealthInsu === "false") {
      setValues((prevValues) => ({
        ...prevValues,
        proceHelathSubDepen: "",
      }));
    }
    if (values.ProceLifeInsu === "false") {
      setValues((prevValues) => ({
        ...prevValues,
        ProceLifeDepenEligible: "",
        proceLifeSpouse: "",
        proceLifeDepenEligibleStatus: "",
        proceLifeSpouseStatus: ""
      }));
    }
    if (values.ProceLifeDepenEligible === "false" || values.ProceLifeDepenEligible === "") {
      setValues((prevValues) => ({
        ...prevValues,
        proceLifeDepenEligibleStatus: ""
      }));
    }
    if (values.proceLifeSpouse === "false" || values.proceLifeSpouse === "") {
      setValues((prevValues) => ({
        ...prevValues,
        proceLifeSpouseStatus: ""
      }));
    }
  }, [values.proceHealthInsu, values.ProceLifeInsu, values.ProceLifeDepenEligible, values.proceLifeSpouse]);

  const verifyValidation = (values) => {
    let errors = {};
    if (!values.dependType) {
      errors.dependType = "Any option must be selected in Depend Type";
    }
    if (!values.decStatus) {
      errors.decStatus = "Any option must be selected in Status";
    }
    if (!values.receivedby) {
      errors.receivedby = "Any option must be selected in Received By";
    }
    if (!values.dependStatus) {
      errors.dependStatus = "Any option must be selected in Status";
    }
    if (!values.proceHealthInsu) {
      errors.proceHealthInsu = "Any option must be selected in Health Insurance";
    }
    if (!values.proceHelathSubDepen && values.proceHealthInsu == "true") {
      errors.proceHelathSubDepen = "Any option must be selected in Subscriber & Dependent";
    }
    if (!values.ProceLifeInsu) {
      errors.ProceLifeInsu = "Any option must be selected in LIFE INSURANCE(YES or NO).";
    }
    if (!values?.ProceLifeDepenEligible && !values.proceLifeSpouse && values.ProceLifeInsu == "true") {
      errors.DOE = "below option must be selected"
    }
    if (values?.ProceLifeDepenEligible == "false" && values.proceLifeSpouse == "false" && values.ProceLifeInsu == "true") {
      errors.DOE = "below option must be selected"
    }
    if (!values?.proceLifeDepenEligibleStatus && values?.ProceLifeDepenEligible == "true" && values.ProceLifeInsu == "true") {
      errors.proceLifeDepenEligibleStatus = "Any option must be selected in proceLifeDepenEligibleStatus"
    }
    if (!values?.proceLifeSpouseStatus && values?.proceLifeSpouse == "true" && values.ProceLifeInsu == "true") {
      errors.proceLifeSpouseStatus = "Any option must be selected in proceLifeSpouseStatus"
    }
    if (!values?.decSsn) {
      errors.decSsn = "SSN is required"
    }
    if (!values?.decDeathPlace) {
      errors.decDeathPlace = "Place of Death is required"
    }
    if (!values?.decDob) {
      errors.decDob = "Date of Birth is required"
    }
    if (!values?.decDod) {
      errors.decDod = "Date of Death is required"
    }
    if (!values?.dependPolicyHolder) {
      errors.dependPolicyHolder = "Policy Holder is required"
    }
    if (!values?.dependSsn) {
      errors.dependSsn = "SSN is required"
    }
    if (!values?.decName) {
      errors.decName = "Name is required"
    }


    console.log("Email ", errors);

    return errors;
  };
  console.log("Dadadadadasdas", values);
  const handleSubmitData = (event) => {
    console.log("hello data");
    if (event) event.preventDefault();
    setErrors(verifyValidation(values));
    console.log("error", errors)


    const err = !values?.decName || !values.dependType || !values.decStatus || !values.receivedby || !values.receivedby || !values?.decDob || !values?.decDod || !values?.decSsn || !values?.dependPolicyHolder || !values?.dependSsn || !values?.decDeathPlace || !values.dependStatus || !values.proceHealthInsu || !values.proceHelathSubDepen && values.proceHealthInsu == "true" || !values.ProceLifeInsu || !values?.ProceLifeDepenEligible && !values.proceLifeSpouse && values.ProceLifeInsu == "true" || values?.ProceLifeDepenEligible == "false" && values.proceLifeSpouse == "false" && values.ProceLifeInsu == "true" || !values?.proceLifeDepenEligibleStatus && values?.ProceLifeDepenEligible == "true" && values.ProceLifeInsu == "true" || !values?.proceLifeDepenEligibleStatus && values?.ProceLifeDepenEligible == "true" && values.ProceLifeInsu == "true" || !values?.proceLifeSpouseStatus && values?.proceLifeSpouse == "true" && values.ProceLifeInsu == "true"

    if (err) {
      ShowError("Please validate form")
      console.log("errrr", errors)
    } else {
      const payload = {
        "id": id || 0,
        "dependentId": userData?.profile?.EmployeeID,
        "dependType": values?.dependType,
        "recBy": values?.receivedby,
        "reportedDate": values?.reportedDate,
        "reportedBy": values?.reportedBy,
        "decName": values?.decName,
        "decStatus": values?.decStatus,
        "decDept": values?.decDept,
        "decDob": values?.decDob,
        "decSsn": values?.decSsn,
        "decDod": values.decDod,
        "decDeathPlace": values?.decDeathPlace,
        "decResidencePlace": values?.decResidencePlace,
        "decNextOfKin": values?.decNextOfKin,
        "decSpouseCil": values?.decSpouseCil,
        "decSpouseCilDept": values.decSpouseCilDept,
        "dependPolicyHolder": values?.dependPolicyHolder,
        "dependSsn": values?.dependSsn,
        "dependStatus": values?.dependStatus,
        "dependDob": values?.dependDob,
        "dependDept": values?.dependDept,
        "docDc": "",
        "docDcDate": "",
        "docFdq": "",
        "docFdqDate": "",
        "docMc": "",
        "docMcDate": "",
        "docBcdc": "",
        "docBcdcDate": "",
        "docPoa": "",
        "docPoaDate": "",
        "docAoe": "",
        "docAoeDate": "",
        "docIr": "",
        "docIrDate": "",
        "docOther": "",
        "docOtherDate": "",
        "proceHealthInsu": values?.proceHealthInsu == "true" ? true : false,
        "proceHelathSubDepen": values?.proceHelathSubDepen === "true" ? true : values?.proceHelathSubDepen === "false" ? false : "",
        "proceLifeInsu": values?.ProceLifeInsu == "true" ? true : false,
        "proceLifeDepenEligible": values?.ProceLifeDepenEligible == "true" ? true : false,
        "proceLifeSpouse": values?.proceLifeSpouse == "true" ? true : false,
        "notes": values?.notes,
        "proceLifeDepenEligibleStatus": values?.proceLifeDepenEligibleStatus,
        "proceLifeSpouseStatus": values?.proceLifeSpouseStatus,
        "familyInfo": JSON.stringify(removeKeyFromObjects(basicDependent, "isSSN")),
        "referenceId": referenceId,
      }

      console.log("paylode", payload)

      axios.post(`${process.env.REACT_APP_API_DOTNET_URL}BenefitsDeathIntake/CreateOrUpdateBenefitsDeath`, payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          },
        }
      ).then((res) => {
        console.log("response", res.data)
        // ShowSucess(res.data.message);
        if (!id) {
          ShowSucess("Successfully Save.");
        } else {
          ShowSucess("Successfully Updated.");
        }
      }).catch((error) => {
        console.log("error", error)
        ShowError("Internal Server Error !");
      })
    }

    // if (
    //   !(
    //     values.Life_Basic ||
    //     values.Life_Additional_Decline ||
    //     values?.Life_Additional_Accepted ||
    //     values?.Life_Dependent_Decline ||
    //     values?.Life_Dependent_Accepted
    //   )
    // ) {
    //   ShowError("atleast 1 insurance select");
    // }

    // if (values.Life_Basic == "Y") {
    //   if (basicDependent?.length) {
    //     let ratioTotal = 0;
    //     basicDependent.map((i) => {
    //       ratioTotal += parseFloat(i.ratio);
    //     });
    //     if (ratioTotal !== 100) {
    //       ShowError("Basic insurance ratio should be 100");
    //     }
    //   }
    // }

    // if (
    //   values.Life_Additional_Decline == "Y" ||
    //   values.Life_Additional_Accepted == "Y"
    // ) {
    //   if (additionInsurance?.length) {
    //     let ratioTotal = 0;
    //     additionInsurance.map((i) => {
    //       ratioTotal += parseFloat(i.ratio);
    //     });
    //     if (ratioTotal !== 100) {
    //       ShowError("Addition insurance ratio should be 100");
    //     }
    //   }
    // }

    // if (
    //   values.Life_Dependent_Accepted == "Y" ||
    //   values.Life_Dependent_Decline == "Y"
    // ) {
    //   if (dependentInsurance?.length) {
    //     let ratioTotal = 0;
    //     dependentInsurance.map((i) => {
    //       ratioTotal += parseFloat(i.ratio);
    //     });
    //     if (ratioTotal !== 100) {
    //       ShowError("Dependent insurance ratio should be 100");
    //     }
    //   }
    // }
  };


  const handleChange = (event) => {
    event.persist();
    setValues((values) => ({
      ...values,
      [event.target.name]: event.target.value,
    }));
  };

  return (
    <Fragment>
      {isDocumentViewer && (
        <DocumentViewer
          open={isDocumentViewer}
          setOpen={setIsDocumentViewer}
          url={documentFile}
          title={documentTitle}
          fullWidth
          maxWidth
          approvalBtn={false}
        />
      )}
      {loding && loadingPanel()}
      <Container fluid={true} className="updView">
        <Row className="bg-primary rounded m-0 p-0 py-1 mb-3 ">
          <Typography variant="h5">
            <Icon style={{ fontSize: "25px", margin: "10px" }} name="graph" />
            Death Intake Form
          </Typography>
        </Row>
        {/* submit button */}
        <Card
          style={{
            marginTop: "10px",
            padding: "10px",
            display: "flex",
            justifyContent: "end",
          }}
        >
          <Button
            onClick={(e) => handleSubmitData()}
            style={{ color: "white" }}
            variant="fill"
            className="btn btn-primary"
          >
            {
              !id ? "Save Death Intake" : "Update Death Intake"
            }
          </Button>
        </Card>
        {/* HR details */}
        <Card style={{ marginTop: "10px" }}>
          <Accordion
            className={classes.root}
            expanded={expanded.empDetail}
            onChange={handleChangeExpanded("empDetail")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2bh-content"
              id="panel2bh-header"
              className="sub-header w-100 p-1 bg-primary text-white"
              style={{ width: "100%" }}
            >
              <FontAwesomeIcon
                icon={faRectangleList}
                className="sub-header"
                style={{
                  // color: "#1569C7",
                  marginRight: "10px",
                  marginTop: "3px",
                }}
              />
              <Typography
                className={classes.heading}
                style={{ height: "auto" }}
              >
                To Be Completed By Human Resources
              </Typography>
            </AccordionSummary>
            <AccordionDetails className="p-0 page-body-wrapper">
              <Card style={{ padding: "20px" }}>
                <Row>
                  <Col md={6}>
                    <div>
                      {plan.InsuranceList.map((i) => {
                        return (
                          <span
                            style={{ display: "inline-block" }}
                            key={i.value}
                          >
                            <Checkbox
                              size={"medium"}
                              value={values?.dependType ? values?.dependType : null}
                              checked={values?.dependType === i.value}
                              onChange={() =>
                                setValues({ ...values, dependType: i.value })
                              }
                            />
                            {i.label}
                          </span>
                        );
                      })}
                    </div>
                    <Errorlable text={errors.dependType} />
                  </Col>
                  <Col md={3}>
                    <div style={{ marginBlockEnd: "-4px" }}>
                      {renderDateTimeInput("reportedDate", "Date/Time")}
                    </div>
                  </Col>
                  <Col md={3}>
                    <div style={{ marginBlockEnd: "-4px" }}>
                      {renderTextInput("reportedBy", "Reported By")}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div>
                      <span>Received By :</span>
                      {plan.ReceivedByList.map((i) => {
                        return (
                          <span
                            style={{ display: "inline-block" }}
                            key={i.value}
                          >
                            <Checkbox
                              size={"medium"}
                              value={values?.receivedby ? values?.receivedby : null}
                              checked={values?.receivedby === i.value}
                              onChange={() =>
                                setValues({ ...values, receivedby: i.value })
                              }
                            />
                            {i.label}
                          </span>
                        );
                      })}
                    </div>
                    <Errorlable text={errors.receivedby} />
                  </Col>
                </Row>
              </Card>
            </AccordionDetails>
          </Accordion>
        </Card>
        {/* End of HR details */}
        {/* User details */}
        <Card style={{ marginTop: "10px" }}>
          <Accordion
            className={classes.root}
            expanded={expanded.empDetail}
            onChange={handleChangeExpanded("empDetail")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2bh-content"
              id="panel2bh-header"
              className="sub-header w-100 p-1 bg-primary text-white"
              style={{ width: "100%" }}
            >
              <FontAwesomeIcon
                icon={faRectangleList}
                className="sub-header"
                style={{
                  // color: "#1569C7",
                  marginRight: "10px",
                  marginTop: "3px",
                }}
              />
              <Typography
                className={classes.heading}
                style={{ height: "auto" }}
              >
                DECEASED INFORMATION
              </Typography>
            </AccordionSummary>
            <AccordionDetails className="p-0 page-body-wrapper">
              <Card style={{ padding: "20px" }}>
                <Row>
                  <Col md={12}>
                    {renderTextInput("decName", "NAME", { required: true })}
                    <Errorlable text={errors.decName} />
                  </Col>
                </Row>
                <Row>
                  <Col md={12} style={{ marginLeft: "5px" }}>
                    <div>
                      <span>STATUS :</span>
                      {plan.StatusList.map((i) => {
                        return (
                          <span
                            style={{ display: "inline-block" }}
                            key={i.value}
                          >
                            <Checkbox
                              size={"medium"}
                              value={values?.decStatus ? values?.decStatus : null}
                              checked={values?.decStatus === i.value}
                              onChange={() =>
                                setValues({ ...values, decStatus: i.value })
                              }
                            />
                            {i.label}
                          </span>
                        );
                      })}
                    </div>
                    <Errorlable text={errors.decStatus} />
                  </Col>
                </Row>
                <Row>
                  <Col md={3}>{renderTextInput("decDept", "DEPT")}</Col>
                  <Col md={3}>
                    {renderDateTimeInput("decDob", "DOB")}
                    <Errorlable text={errors.decDob} />
                  </Col>
                  <Col md={3}>
                    {renderTextInput(
                      "decSsn",
                      "SSN",
                      { type: showPassword ? "text" : "password", required: true, maxLength: 9 },

                      <IconButton
                        aria-label="toggle password visibility"
                        edge="end"
                        onClick={handleTogglePassword}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>

                    )}
                    <Errorlable text={errors.decSsn} />
                  </Col>
                  <Col md={3}>
                    {renderDateTimeInput("decDod", "DOD")}
                    <Errorlable text={errors.decDod} />
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    {renderTextInput("decDeathPlace", "PLACE OF DEATH", { required: true })}
                    <Errorlable text={errors.decDeathPlace} />
                  </Col>
                  <Col md={6}>
                    {renderTextInput("decResidencePlace", "PLACE OF RESIDENCE")}
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    {renderTextInput("decNextOfKin", "NEXT OF KIN")}
                  </Col>
                  <Col md={3}>
                    <Col style={{ textAlign: "center" }}>
                      <Col>
                        <span style={{ marginTop: "10px" }}>
                          SPOUSE/CIL GOVGUAM?
                        </span>
                      </Col>
                      <Col>
                        <span>
                          {renderCheckbox1(0, "medium", "decSpouseCil", "Yes")} Yes
                        </span>
                        <span>
                          {renderCheckbox1(0, "medium", "decSpouseCil", "No")} No
                        </span>
                      </Col>
                    </Col>
                    {/* <Errorlable text={errors.workHr} /> */}
                  </Col>
                  <Col md={3}>
                    {renderTextInput("decSpouseCilDept", "SPOUSE/CIL DEPT")}
                  </Col>
                  {/* <Col md={2}>
                    {renderTextInput("homePhone", "Phone Number")}
                  </Col>
                  <Col md={2}>
                    {renderTextInput("deptName", "Agency/Department Number")}
                  </Col> */}
                </Row>
              </Card>
            </AccordionDetails>
          </Accordion>
        </Card>
        {/* End of User details */}
        {/* Dependent Info */}
        <Card style={{ marginTop: "10px" }}>
          <Accordion
            className={classes.root}
            expanded={expanded.dependent}
            onChange={handleChangeExpanded("dependent")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2bh-content"
              id="panel2bh-header"
              className="sub-header w-100 p-1 bg-primary text-white"
              style={{ width: "100%" }}
            >
              <FontAwesomeIcon
                icon={faRectangleList}
                className="sub-header"
                style={{
                  // color: "#1569C7",
                  marginRight: "10px",
                  marginTop: "3px",
                }}
              />
              <Typography
                className={classes.heading}
                style={{ height: "auto" }}
              >
                DEPENDENT LIFE INFORMATION (Note: Update Dependent Coverage If
                No Eligible Dependents Exist)
              </Typography>
            </AccordionSummary>
            <AccordionDetails className="p-0 page-body-wrapper">
              <Card style={{ padding: "20px" }}>
                <Row>
                  <Col md={8}>
                    {renderTextInput("dependPolicyHolder", "POLICY HOLDER", { required: true })}
                    <Errorlable text={errors.dependPolicyHolder} />
                  </Col>
                  <Col md={4}>
                    {renderTextInput(
                      "dependSsn",
                      "SSN",
                      { type: showPasswordsecond ? "text" : "password", required: true, maxLength: 9 },
                      <IconButton
                        aria-label="toggle password visibility"
                        edge="end"
                        onClick={handleTogglePasswordSecond}
                      >
                        {showPasswordsecond ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    )}
                    <Errorlable text={errors.dependSsn} />
                  </Col>
                </Row>
                <Row>
                  <Col md={7}>
                    <div>
                      <span>STATUS :</span>
                      {plan.StatusList.filter(
                        (item) => item?.label != "DEPENDENT"
                      ).map((i) => {
                        return (
                          <span
                            style={{ display: "inline-block" }}
                            key={i.value}
                          >
                            <Checkbox
                              size={"medium"}
                              value={values?.dependStatus ? values?.dependStatus : null}
                              checked={values?.dependStatus === i.value}
                              onChange={() =>
                                setValues({ ...values, dependStatus: i.value })
                              }
                            />
                            {i.label}
                          </span>
                        );
                      })}
                    </div>
                    <Errorlable text={errors.dependStatus} />
                  </Col>
                  <Col md={2}>{renderDateInput("dependDob", "DOB")}</Col>
                  <Col md={3}>{renderTextInput("dependDept", "DEPT")}</Col>
                </Row>
              </Card>
            </AccordionDetails>
          </Accordion>
        </Card>
        {/* End of Dependent Info */}
        {/* <Card style={{ marginTop: "10px" }}>
          <Accordion
          className={classes.root}
            expanded={expanded.familyInfo}
            onChange={handleChangeExpanded("familyInfo")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2bh-content"
              id="panel2bh-header"
              className="sub-header w-100 p-1 bg-primary text-white"
              style={{ width: "100%" }}
            >
              <FontAwesomeIcon
                icon={faRectangleList}
                className="sub-header"
                style={{
                  // color: "#1569C7",
                  marginRight: "10px",
                  marginTop: "3px",
                }}
              />
              <Typography
                className={classes.heading}
                style={{ height: "auto" }}
              >
                FAMILY INFORMATION
              </Typography>
            </AccordionSummary>
            <AccordionDetails className="p-0 page-body-wrapper">
              <Card style={{ padding: "20px" }}>
                <Row>
                  <Col md={8}>
                    {renderTextInput("mailingAddress", "POLICY HOLDER")}
                  </Col>
                  <Col md={4}>
                    {renderTextInput("mailingAddress", "SSN")}
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <div>
                      <span>
                        STATUS :
                      </span>
                        {plan.StatusList.filter((item)=>item?.label != "DEPENDENT").map((i) => {
                          return (
                            <span
                              style={{ display: "inline-block" }}
                              key={i.value}
                            >
                              <Checkbox
                                size={"medium"}
                                value={values?.gender ? values?.gender : null}
                                checked={values?.gender === i.value}
                                onChange={() =>
                                  setValues({ ...values, gender: i.value })
                                }
                              />
                              {i.label}
                            </span>
                          );
                        })}
                    </div>
                  </Col>
                  <Col md={3}>{renderTextInput("city", "DOB")}</Col>
                  <Col md={3}>
                    {renderTextInput("state", "DEPT")}
                  </Col>
                </Row>
              </Card>
            </AccordionDetails>
          </Accordion>
        </Card> */}
        <Card style={{ marginTop: "10px" }}>
          <Accordion
            className={classes.root}
            expanded={expanded.familyInfo}
            onChange={handleChangeExpanded("familyInfo")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2bh-content"
              id="panel2bh-header"
              className="sub-header w-100 p-1 bg-primary text-white"
              style={{ width: "100%" }}
            >
              <FontAwesomeIcon
                icon={faRectangleList}
                className="sub-header"
                style={{
                  // color: "#1569C7",
                  marginRight: "10px",
                  marginTop: "3px",
                }}
              />
              <Typography
                className={classes.heading}
                style={{ height: "auto" }}
              >
                FAMILY INFORMATION
              </Typography>
            </AccordionSummary>
            <AccordionDetails className="p-0 page-body-wrapper">
              <Depedentinformation
                dependentInformation={basicDependent}
                setDependentInformation={setBasicDependant}
                initialDependent={basicInsurance}
                // handleDependentUpdate={handleDependentUpdate}
                handleDependentDelete={handleBasicInsuranceDelete}
                // setClassValues={setClassValues}
                // values={values?.healthDeductionClass}
                btnhide={true}
              />
            </AccordionDetails>
          </Accordion>
        </Card>
        {/* Document */}
        <Card style={{ marginTop: "10px" }}>
          <Accordion
            className={classes.root}
            expanded={expanded.document}
            onChange={handleChangeExpanded("document")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2bh-content"
              id="panel2bh-header"
              className="sub-header w-100 p-1 bg-primary text-white"
              style={{ width: "100%" }}
            >
              <FontAwesomeIcon
                icon={faRectangleList}
                className="sub-header"
                style={{
                  // color: "#1569C7",
                  marginRight: "10px",
                  marginTop: "3px",
                }}
              />
              <Typography
                className={classes.heading}
                style={{ height: "auto" }}
              >
                DOCUMENTS
              </Typography>
            </AccordionSummary>
            <AccordionDetails className="p-0 page-body-wrapper">
              <Card style={{ padding: "20px" }}>
                <Row>
                  <Col style={{ display: "flex", flexDirection: "column" }}>
                    {/* {JSON.stringify(checkedStates)} */}
                    {
                      documents.map((i) => {
                        return <div>
                          {renderUploadSection(i.index, i.title, i.docName, i.sourceId, checkedStates)}

                        </div>
                      })
                    }
                    {/* <div>
                      {renderUploadSection(0, "DEATH CERTIFICATE", "docDc",1220)}
                      
                    </div>
                    <div>
                      {renderUploadSection(
                        1,
                        "FOREIGN DEATH QUESTIONNAIRE",
                        "docFdq",
                        1221
                      )}
                      
                    </div>
                    <div>
                      {renderUploadSection(
                        2,
                        "MARRIAGE CERTIFICATE",
                        "docMc",
                        1222
                      )}

                       
                    </div>
                    <div>
                      {renderUploadSection(
                        3,
                        "BIRTH CERTIFICATE– FOR DEPENDENT COVERAGE (STEPCHILD)",
                        "docBcdc",
                        1223
                      )}
                    </div>
                    <div>
                      {renderUploadSection(4, "POWER OF ATTORNEY", "docPoa",1224)}
                    </div>
                    <div>
                      {renderUploadSection(5, "ADMIN OF ESTATES", "docAoe",1225)}
                    </div>
                    <div>
                      {renderUploadSection(6, "ITEMIZED RECEIPTS", "docIr",1226)}
                    </div>
                    <div>{renderUploadSection(7, "OTHER", "docOther",1227)}</div> */}
                  </Col>
                </Row>
                {/* <Row>
                  <Col md={6}>
                    <div>
                      <span>
                        STATUS :
                      </span>
                        {plan.StatusList.filter((item)=>item?.label != "DEPENDENT").map((i) => {
                          return (
                            <span
                              style={{ display: "inline-block" }}
                              key={i.value}
                            >
                              <Checkbox
                                size={"medium"}
                                value={values?.gender ? values?.gender : null}
                                checked={values?.gender === i.value}
                                onChange={() =>
                                  setValues({ ...values, gender: i.value })
                                }
                              />
                              {i.label}
                            </span>
                          );
                        })}
                    </div>
                  </Col>
                  <Col md={3}>{renderTextInput("city", "DOB")}</Col>
                  <Col md={3}>
                    {renderTextInput("state", "DEPT")}
                  </Col>
                </Row> */}
              </Card>
            </AccordionDetails>
          </Accordion>
        </Card>
        {/*END Document */}
        {/* PROCESSING */}
        <Card style={{ marginTop: "10px" }}>
          <Accordion
            className={classes.root}
            expanded={expanded.process}
            onChange={handleChangeExpanded("process")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2bh-content"
              id="panel2bh-header"
              className="sub-header w-100 p-1 bg-primary text-white"
              style={{ width: "100%" }}
            >
              <FontAwesomeIcon
                icon={faRectangleList}
                className="sub-header"
                style={{
                  // color: "#1569C7",
                  marginRight: "10px",
                  marginTop: "3px",
                }}
              />
              <Typography
                className={classes.heading}
                style={{ height: "auto" }}
              >
                PROCESSING
              </Typography>
            </AccordionSummary>
            <AccordionDetails className="p-0 page-body-wrapper">
              <Card style={{ padding: "20px" }}>
                <Col>
                  <b>HEALTH INSURANCE</b>
                  <Col>
                    <p>Deceased covered under GovGuam Insurance?</p>
                    <Errorlable text={errors.proceHealthInsu} />
                    <Col>
                      <span>
                        {renderCheckbox1(0, "medium", "proceHealthInsu", "true")} YES
                      </span>
                      <span>
                        {renderCheckbox1(0, "medium", "proceHealthInsu", "false")} NO
                      </span>
                    </Col>
                  </Col>
                  {
                    values.proceHealthInsu == "true" ?
                      <Col>
                        <p>If YES,</p><Errorlable text={errors.proceHelathSubDepen} />
                        <Row>
                          <span>
                            {renderCheckbox1(0, "medium", "proceHelathSubDepen", "true")}{" "}
                            Subscriber: complete COS form to Terminate on DOD.
                          </span>
                          <span>
                            {renderCheckbox1(0, "medium", "proceHelathSubDepen", "false")}{" "}
                            Dependent: complete COS to remove from plan; effective
                            DOD. Verify Change of Class.
                          </span>
                        </Row>
                      </Col> : null
                  }
                </Col>
                <Col style={{ marginTop: "12px" }}>
                  <b>LIFE INSURANCE </b>
                  <Col>
                    <p>Dependent Claim or Surviving Spouse</p>
                    <Errorlable text={errors.ProceLifeInsu} />
                    <Col>
                      <span>
                        {renderCheckbox1(0, "medium", "ProceLifeInsu", "true")} YES
                      </span>
                      <span>
                        {renderCheckbox1(0, "medium", "ProceLifeInsu", "false")} NO
                      </span>
                    </Col>
                  </Col>
                  {values.ProceLifeInsu == "true" ?
                    <div>
                      <Col>
                        <Errorlable text={errors.DOE} />
                        <Row>
                          <Row>
                            <span>
                              {renderCheckbox1(0, "medium", "ProceLifeDepenEligible", "true")} If
                              Dependent (DEP.) Claim, any other eligible dependents?
                            </span>
                          </Row>
                          {
                            values?.ProceLifeDepenEligible == "true" ?
                              <div>
                                <Col style={{ marginLeft: "30px" }}>
                                  <Errorlable text={errors.proceLifeDepenEligibleStatus} />
                                  <span>
                                    {renderCheckbox1(0, "medium", "proceLifeDepenEligibleStatus", "YES")}
                                    YES, maintain Dep. Coverage
                                  </span>
                                  <span>
                                    {renderCheckbox1(0, "medium", "proceLifeDepenEligibleStatus", "NO")} NO,
                                    Complete Change of Status form to cancel dep. coverage
                                  </span>
                                </Col>
                              </div> : null
                          }
                        </Row>
                      </Col>
                      <Col>
                        <Row>
                          <Row>
                            <span>
                              {renderCheckbox1(0, "medium", "proceLifeSpouse", "true")} If
                              Surviving Spouse, is he/she also an employee/retiree?
                            </span>
                          </Row>
                          {values?.proceLifeSpouse == "true" ?
                            <div>
                              <Col style={{ marginLeft: "30px" }}>
                                <Errorlable text={errors.proceLifeSpouseStatus} />
                                <span>
                                  {renderCheckbox1(0, "medium", "proceLifeSpouseStatus", "YES")}
                                  YES, update beneficiary
                                </span>
                                <span>
                                  {renderCheckbox1(0, "medium", "proceLifeSpouseStatus", "NO")} NO,
                                  no action needed
                                </span>
                              </Col>
                            </div> : null
                          }
                        </Row>
                      </Col>
                    </div> : null
                  }
                </Col>
              </Card>
            </AccordionDetails>
          </Accordion>
        </Card>
        {/*END PROCESSING */}
        {/* NOTES */}
        <Card style={{ marginTop: "10px", marginBottom: "30px" }}>
          <Accordion
            className={classes.root}
            expanded={expanded.notice}
            onChange={handleChangeExpanded("notice")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2bh-content"
              id="panel2bh-header"
              className="sub-header w-100 p-1 bg-primary text-white"
              style={{ width: "100%" }}
            >
              <FontAwesomeIcon
                icon={faRectangleList}
                className="sub-header"
                style={{
                  // color: "#1569C7",
                  marginRight: "10px",
                  marginTop: "3px",
                }}
              />
              <Typography
                className={classes.heading}
                style={{ height: "auto" }}
              >
                NOTES
              </Typography>
            </AccordionSummary>
            <AccordionDetails className="p-0 page-body-wrapper">
              <Card style={{ padding: "20px" }}>
                <Row>
                  <Col>
                    {renderTextInput("notes", "NOTES", {
                      multiline: true,
                    })}
                  </Col>
                </Row>
              </Card>
            </AccordionDetails>
          </Accordion>
        </Card>
        {/*END NOTES */}
      </Container>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    documentState: state,
    documentFields: state.DocumentUploadReducer.documentFields,
    documentSources: state.DocumentUploadReducer.documentSources,
    uploadedDocumentAttechment:
      state.DocumentUploadReducer.uploadedDocumentAttechment,
    loading: state.DocumentUploadReducer.loading,
    documentReferenceId:
      state.DocumentUploadReducer?.uploadedDocumentAttechment?.referenceId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getDocumentFields,
      getDocumentSources,
      postDocuments,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(DeathIntake);

// export default DeathIntake;
